import * as ActionTypes from '../constants/ActionTypes';

export const setGlobalState = (data) => {
  return {
    type: ActionTypes.SET_GLOBAL_STATE,
    payload: data
  };
};